import { MinusIcon, PlusIcon } from '../icons'

// − n + for servings (recipe detail, a planned meal). Bounds disable the button
// rather than wrapping, and the value is read out with the group's label.
// `of` names what it belongs to when several are on screen (a meal per day).
export function Stepper({ value, min, max, label, of, unit, size = 'md', onChange }: {
  value: number
  min: number
  max: number
  label: string
  of?: string
  unit?: string
  size?: 'sm' | 'md'
  onChange: (n: number) => void
}) {
  const suffix = of ? ` for ${of}` : ''
  const noun = label.toLowerCase() + suffix
  return (
    <div className={`ml-stepper ml-stepper--${size}`} role="group" aria-label={label + suffix}>
      <div className="ml-stepper__box">
        <button type="button" className="ml-stepper__btn" aria-label={`Fewer ${noun}`}
          disabled={value <= min} onClick={() => onChange(Math.max(min, value - 1))}>
          <MinusIcon size={size === 'sm' ? 14 : 18} />
        </button>
        <span className="ml-stepper__value ml-num" aria-live="polite">{value}</span>
        <button type="button" className="ml-stepper__btn" aria-label={`More ${noun}`}
          disabled={value >= max} onClick={() => onChange(Math.min(max, value + 1))}>
          <PlusIcon size={size === 'sm' ? 14 : 18} />
        </button>
      </div>
      {unit && <span className="ml-stepper__unit">{unit}</span>}
    </div>
  )
}
